'use es6';

export const getCertificationsRequestState = state => state.certifications.requestState;
export const getCertifications = state => state.certifications.data;